<script lang="ts">
  // The activity types that sync, as chips, with Edit (which opens ActivityTypesDialog). The
  // sport's own types are locked: they always sync.
  import { Button } from '$lib/components/ui/button'

  export let defaultTypes: string[] = []
  export let chosenTypes: string[]
  export let label: (type: string) => string = (type) => type
  export let disabled = false

  $: empty = !defaultTypes.length && !chosenTypes.length
</script>

<div class="flex flex-col gap-2 py-3">
  <div class="flex items-center justify-between gap-4">
    <span class="text-sm font-medium text-foreground">Activity types</span>
    <Button variant="outline" size="sm" {disabled} on:click>
      <i class="fa-solid fa-pen mr-2" aria-hidden="true" /> Edit
    </Button>
  </div>
  {#if empty}
    <p class="m-0 text-xs text-muted-foreground">No activity types chosen.</p>
  {:else}
    <ul class="m-0 flex list-none flex-wrap gap-1.5 p-0" aria-label="Activity types that sync">
      {#each defaultTypes as type}
        <li class="rounded-full bg-secondary px-2.5 py-1 text-xs font-medium text-secondary-foreground" title="Always synced for your sport">
          <i class="fa-solid fa-lock mr-1 text-[10px] opacity-60" aria-hidden="true" />{label(type)}
        </li>
      {/each}
      {#each chosenTypes as type}
        <li class="rounded-full border border-border px-2.5 py-1 text-xs font-medium text-foreground">{label(type)}</li>
      {/each}
    </ul>
  {/if}
</div>
